/**
 * Button used in the Log In page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import './LogInButton.css'

import Button from '@/components/Button/Button'
import { Link } from 'react-router-dom'

interface LogInButtonProps {
  text: string
  disabled?: boolean
  type?: 'submit' | 'reset' | 'button' | undefined
  toLink?: string
  dark?: boolean
}

const LogInButton = (props: LogInButtonProps) => {
  return (
    <>
      {props.type !== undefined ? (
        <button
          type={props.type}
          className="button button-large button-dark login-button"
          disabled={props.disabled}
        >
          <div className="button button-label">{props.text}</div>
        </button>
      ) : (
        <Button
          as={Link}
          className="login-button"
          to={props.toLink}
          label={props.text}
          dark={props.dark}
        />
      )}
    </>
  )
}

export default LogInButton
